// Ticket-Status für Objekt und Einheit – Bezeichnungen wie im Ticketbereich (STATUS_FLOW).

const LABEL: Record<string, string> = {
  neu: 'Neu', offen: 'Offen', in_bearbeitung: 'In Bearbeitung', warten_auf_rueckmeldung: 'Warte auf Mieter',
  warten_auf_dienstleister: 'Warte auf DL', eskaliert: 'Eskaliert', erledigt: 'Erledigt', geschlossen: 'Geschlossen',
};

export function istTicketOffen(status: string | null | undefined): boolean {
  return status !== 'erledigt' && status !== 'geschlossen';
}

export function ticketStatusLabel(status: string | null | undefined): string {
  return LABEL[status ?? ''] ?? (status || 'Neu');
}
